export enum AssetType {
  Image = 'image',
  Video = 'video',
  Widget = 'widget'
}

/** Value for "HLS only" in gallery/asset-picker type filter (not a DB type). */
export const HLS_FILTER_VALUE = 'hls' as const

/** Value for "Playlist" in gallery type filter (not an asset DB type). */
export const PLAYLIST_FILTER_VALUE = 'playlist' as const

/** Gallery/asset-picker type filter: AssetType or synthetic 'hls' for HLS-only video. */
export type AssetTypeFilterValue = AssetType | typeof HLS_FILTER_VALUE

/** Gallery type filter including the 'playlist' tab. */
export type GalleryTypeFilter = AssetTypeFilterValue | typeof PLAYLIST_FILTER_VALUE
